<script>
import Detail from './detail'
import DatePicker from "@vuepic/vue-datepicker"
import BadgeSeamless from "@/components/badge-seamless"
import BadgeTransactionType from "@/components/badge-transaction-type"
import BadgeTransactionCategory from "@/components/badge-transaction-category"
import BadgeGameCategory from "@/components/badge-game-category"
// import BadgeGameTarget from "@/components/badge-game-target"
import EvolutionParser from "@/libraries/vendor/evolution-v3"
import BGParser from "@/libraries/vendor/bg-v3"
import DGParser from "@/libraries/vendor/dg-v3"
import AGParser from "@/libraries/vendor/ag-v3"
import BotaParser from "@/libraries/vendor/bota-v3"
import VivoParser from "@/libraries/vendor/vivo-v3"
import WmParser from "@/libraries/vendor/wm-v3"
import SelectVendors from "@/components/select-vendors"
import SelectGames from "@/components/select-games"
import { md5 } from '@/helpers/string';
import PartnerBadge from '@/components/badge-level.vue'

export default {
  props: {
    user:Object,
    searchByUser:Boolean
  },
  components: {
    Detail,
    DatePicker,
    // PartnerTreeMenu,
    PartnerBadge,
    BadgeSeamless,
    BadgeTransactionType,
    BadgeTransactionCategory,
    BadgeGameCategory,
    // BadgeGameTarget,
    SelectVendors,
    SelectGames
  },
  data() {
    return {
      search: {
        groupKey: '',
        searchType: 'username',
        searchText: '',
        method: 'game',
        category: 'turn',
        type: 'bet',
        vendor: '',
        game: '',
        seamlessState: '',
        beginDate: '',
        endDate: '',
        parent: null
      },
      filter: {
        resultType: ''
      },
      sort: { createdAt: -1 },
      list: [],
      limit: 50,
      totalCount: 0, // 총갯수
      totalPageCount: 0, // 총 페이지수
      page: 1, // 현재 페이지
      groups: {},
      groupedList: [],
      vendors: [],
      games: [],
      evolutionParser: new EvolutionParser(),
      bgParser: new BGParser(),
      dgParser: new DGParser(),
      agParser: new AGParser(),
      botaParser: new BotaParser(),
      vivoParser: new VivoParser(),
      wmParser: new WmParser()
    }
  },
  created() {

  },
  mounted() {
    let beginDate = new Date()
    beginDate.setDate(beginDate.getDate() - 1)
    beginDate.setHours(0)
    beginDate.setMinutes(0)
    beginDate.setSeconds(0)
    // let endDate = new Date()

    this.search.beginDate = beginDate
    // this.search.endDate = endDate

    const a = localStorage.getItem('limit')
    this.limit = (a !== 'NaN' && a) ? parseInt(a) : 50

    this.search.parent = this.parent ? this.parent.id : null

    if(this.searchByUser == true) {
      if(this.user.username) this.search.searchText = this.user.username
      // this.searchList().then()
    }
    this.searchList().then()
    //else this.$refs.partnerTreeMenu.getPartners().then()
  },
  methods: {
    setParent: function(id) {
      this.search.parent = id
    },
    setSort: function(field) {
      let dir
      if (this.sort[field]) {
        dir = this.sort[field] * -1
      } else {
        dir = -1
      }

      this.sort = {}
      this.sort[field] = dir
      this.searchList().then()
    },
    goFirst() {
      this.page = 1
    },
    goPre() {
      if (this.page === 1) {
        this.page = 1
      } else {
        this.page -= 1
      }
    },
    goNext() {
      this.page += 1
    },
    searchByPage: function(page) {
      this.page = page
    },
    searchList: async function() {

      const loader = this.$loading.show()
      try {
        localStorage.setItem('limit', this.limit)
        const params = {
          search: { method: this.search.method, category: this.search.category, type: this.search.type, vendor: this.search.vendor, game: this.search.game, seamlessState: this.search.seamlessState, parent: this.search.parent },
          // search: { method: this.search.method, category: this.search.category, type: this.search.type, vendor: 96, game: this.search.game, seamlessState: this.search.seamlessState, parent: this.search.parent },
          sdate: this.search.beginDate,
          edate: this.search.endDate,
          sort: this.sort,
          limit: this.limit,
          page: this.page
        }
        params.search[this.search.searchType] = this.search.searchText

        if(this.filter && this.filter.resultType) {
          params.filter = {
            resultType: this.filter.resultType
          }
        }

        const result = await this.$API.transaction.games(params)

        if (result.code !== 0) {
          return alert(result.msg)
        }

        this.list = []
        for(let key in result.documents) {
          let doc = result.documents[key]
          if (doc.detail) {
            if (doc.vendorKey === 'evolution_casino') {
              doc.info = this.evolutionParser.set(doc.detail)
            }
            else if(doc.vendorKey === 'bg_casino'){
              doc.info = this.bgParser.set(doc.detail)
            }
              // else if(doc.vendorKey === 'dg_casino'){
              //   doc.info = this.dgParser.set(doc)
            // }
            else if(doc.vendorKey === 'wm_casino'){
              doc.info = this.wmParser.set(doc)
            }
            doc.showDetail = false
          }
          if(doc.vendorKey === 'ag_casino' && doc.children.length > 0){
            doc.info = this.agParser.set(doc)
          }
          else if(doc.vendorKey === 'bota_casino' && doc.children.length > 0){
            doc.info = this.botaParser.set(doc)
          }
          else if(doc.vendorKey === 'vivo_casino' && doc.children.length > 0){
            doc.info = this.vivoParser.set(doc)
          }

          this.list.push(doc)
        }

        this.groupedList = []
        this.groups = {}
        this.list.forEach(record => {
          const code = record.data.transaction_code;
          if (!this.groups[code]) this.groups[code] = []
          this.groups[code].push(record)
        })

        for (const [code, records] of Object.entries(this.groups)) {
          let childrens = []
          records.forEach(x => {
            if (x.children && x.children.length > 0) {
              x.children.forEach(child => {
                childrens.push(child);
              });
            }
          })

          this.groupedList.push({
            list : records,
            code : code,
            "detail": records[records.length - 1].detail || {},
            childrenList : {
              [code] : childrens
            }
          });
        }

        // console.log("[그룹 리스트] >>>>",this.groupedList)

        this.totalCount = result.totalCount
        this.totalPageCount = result.totalPageCount
      } catch(e) {
        this.$log.error(e)
      } finally {
        loader.hide()
      }
    },

    searchVendors(id) {
      this.search.vendor = id
      this.$refs.refSearchGames.getGames(id)
    },

    selectGames(id) {
      this.search.game = id
    },

    // 전송 데이터
    openData: function(data) {
      this.$refs['modal-detail'].open(data)
    },

    // 에볼, 프라그마틱, 드림게이밍 등 상세정보
    async openDetail(record) {
      let vType
      let vKeyType = record.vendorKey.split('_');
      if(vKeyType[1] === 'casino'){
        vType = 'casino'
      } else {
        vType = 'slot'
      }

      if (record.vendorKey === 'dg_casino') {
        const hash = md5(record.data.transaction_code+"878184ed37ef29322b414dcf7cb7e847")
        const url = `https://neo-game.app/bet-detail/${record.data.transaction_code}/${hash}`
        window.open(url, '', 'top=100, left=500, width=1500, height=1000 status=no, menubar=no, toolbar=no, resizable=no')
        return;
      }

      if (record.vendorKey === 'pragmatic_slot') {
        const result = await this.$API.transaction.getPragmaticLink(record.transactionKey)
        if (result.code !== 0) {
          return alert(result.msg)
        }
        window.open(result.url)
      }
      else if (
        vType === 'slot'
        /*
        record.vendorKey === 'fghub' || record.vendorKey === 'cq9_slot' || record.vendorKey === 'mtv_casino' ||
        record.vendorKey === 'dcs' || record.vendorKey === 'booongo_slot' || record.vendorKey === 'habanero_slot'||
        record.vendorKey === 'netgaming_slot' || record.vendorKey === 'gameart' || record.vendorKey === 'ftg_slot'||
        record.vendorKey === 'naga_slot' || record.vendorKey === 'aspect_slot' || record.vendorKey === 'ps'||
        record.vendorKey === 'pgsoft_slot' || record.vendorKey === 'skywind_slot' || record.vendorKey === 'netent_slot' ||
        record.vendorKey === 'redtiger_slot' || record.vendorKey === 'btg_slot'

         */
      ) {

        // 게임사와 매칭되는 벤더키를 보내준다.
        let vKey
        if(record.vendorKey === 'blueprint_slot' || record.vendorKey === 'dragoon_slot' || record.vendorKey === 'elysium_slot' || record.vendorKey === 'quickspin_slot' || record.vendorKey === 'redrake_slot' || record.vendorKey === 'spearhead_slot'){
          vKey = 'fghub'
        } else if(record.vendorKey === 'cq9_slot'){
          vKey = 'cq9'
        } else if(record.vendorKey === 'mtv_casino'){
          vKey = 'mtv'
        } else if(record.vendorKey === 'png_slot' || record.vendorKey === 'nlc_slot' || record.vendorKey === 'evo_slot' || record.vendorKey === 'hs_slot' || record.vendorKey === 'aux_slot' || record.vendorKey === 'relax_slot' || record.vendorKey === 'reelplay_slot' || record.vendorKey === 'fantasma_slot' || record.vendorKey === 'boomerang_slot' || record.vendorKey === '4tp_slot') {
          vKey = 'dcs'
        } else if(record.vendorKey === 'booongo_slot' || record.vendorKey === 'playson_slot'){
          vKey = 'booongo'
        } else if(record.vendorKey === 'habanero_slot' || record.vendorKey === 'gmw_slot'){
          vKey = 'habanero'
        } else if(record.vendorKey === 'netgaming_slot'){
          vKey = 'netgaming'
        } else if(record.vendorKey === 'gameart_slot'){
          vKey = 'gameart'
        } else if(record.vendorKey === 'ftg_slot'){
          vKey = 'ftg'
        } else if(record.vendorKey === 'naga_slot') {
          vKey = 'naga'
        } else if(record.vendorKey === 'aspect_slot'){
          vKey = 'aspect'
        } else if(record.vendorKey === 'ps_slot'){
          vKey = 'ps'
        } else if(record.vendorKey === 'pgsoft_slot'){
          vKey = 'pgsoft'
        } else if(record.vendorKey === 'skywind_slot'){
          vKey = 'skywind'
        } else if(record.vendorKey === 'netent_slot' || record.vendorKey === 'redtiger_slot' || record.vendorKey === 'btg_slot'){
          vKey = 'evolution'
        }

        const result = await this.$API.transaction.getSlotDetailLink(vKey, record.data.params.transactionKey)
        if (result.code !== 0) {
          return alert(result.msg)
        }
        window.open(result.url)
      }
      else if (record.vendorKey === 'oriental_casino') {
        window.open(record.children[0].data.result_url)
      }
      else if(record.vendorKey === 'bg_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultBG')
      }
      else if(record.vendorKey === 'wm_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultWM')
      }
      else if(record.vendorKey === 'vivo_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultVIVO')
      }
      else if(record.vendorKey === 'ag_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultAG')
      }
      else if(record.vendorKey === 'bota_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultBota')
      }
      else if(record.vendorKey === 'evolution_casino') {
        this.$refs['modal-detail'].open(record, 'detailResultEvolution')
      }
      else {
        // 에볼등 게임 상세내역 화면
        this.$refs['modal-detail'].open(record, 'detailResult')
      }
    },
    async openSeamlessLog(record) {
      this.$refs['modal-detail'].open(record, 'detailSeamless')
    }
  },
  watch: {
    page: function() {
      this.searchList().then()
    }
  }
}
</script>

<style scoped>


.card-image{
  width: 23px;
  height: auto;
}


.betting-table th, .history-table th {
  background-color: #f9f9f9;
  padding: 10px;
  text-align: center;
  font-weight: 500;
  color: #555;
}

.betting-table td, .history-table td {
  padding: 12px 10px;
  border-bottom: 1px solid #eee;
}


.cards-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 16px;

}
.player-label, .banker-label {
  font-weight: 500;
  margin-bottom: 4px;
  margin-right: 5px;
  margin-left: 5px;
}

.cards-p{
  display: flex;
  flex-direction: column;
  align-items: flex-end;   /* 오른쪽 정렬 */
  justify-content: center;  /* 수직 중앙 */
  width: 48%;
  text-align: center;       /* 내부 텍스트 중앙 */
}
.cards-b {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* 왼쪽 정렬 */
  justify-content: center;  /* 수직 중앙 */
  width: 48%;
  text-align: center;       /* 내부 텍스트 중앙 */
}

.cards {
  display: flex;
  margin-bottom: 8px;
}

.card {
  display: inline-block;

  margin-left: 4px;
  padding: 6px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.card-value {
  font-size: 15px;
  height: 33%;
  margin-right: 8px;
  margin-left: 8px;
  font-weight: 800;
  width: 20px;
  background-color: white;
  border: 1px solid darkgray;
  border-radius: 6px;
}

.border-bottom-custom {
  border-bottom: 25px solid rgba(179, 229, 252, 0.1);
}

</style>
<template>
  <div>
    <form class="header-search" @submit.prevent="searchList">

      <!-- 검색 //-->
      <div class="row">
        <div class="col-md-2" v-if="searchByUser != true"></div>
        <div class="form-group col-md-2 mb-2">
          <select-vendors @searchVendors="searchVendors"></select-vendors>
        </div>

        <div class="form-group col-md-2 mb-2">
          <select-games @selectGames="selectGames" ref="refSearchGames"></select-games>
        </div>

        <div class="form-group col-md-1 mb-2">
          <select class="form-select" v-model="search.seamlessState">
            <option value="">{{ $t('전체거래') }}</option>
            <option value="ready">트랜스퍼거래</option>
            <option value="finish">심리스거래(완료)</option>
            <option value="error">심리스거래(오류)</option>
          </select>
        </div>

        <div class="form-group col-md-2 mb-2">
          <select class="form-select" v-model="filter.resultType">
            <option value="">{{ $t('게임결과') }}</option>
            <option value="win">{{ $t('승') }}</option>
            <option value="draw">{{ $t('무') }}</option>
            <option value="lose">{{ $t('패') }}</option>
            <option value="cancel">{{ $t('취소') }}</option>
          </select>
        </div>

        <div class="form-group col-md-1 mb-2">
          <select class="form-select" v-model="search.searchType">
            <option value="username">{{ $t('아이디') }}</option>
            <option value="siteUsername">{{ $t('사이트 아이디') }}</option>
            <option value="parentTransactionKey">{{ $t('거래코드') }}</option>
          </select>
        </div>

        <div class="form-group col-md-2 mb-2">
          <input type="text" class="form-control" v-model="search.searchText" :placeholder="$t('검색어')" />
        </div>
      </div>

      <!-- 페이징 및 검색 //-->
      <div class="row">
        <div class="col-md-3">
          <div class="form-group mb-2">
            <DatePicker
              v-model="search.beginDate"
              :format="'yyyy-MM-dd HH:mm:ss'"
              utc
              auto-apply
              :close-on-auto-apply="false"
              :placeholder="$t('시작일')"
            ></DatePicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-2">
            <DatePicker
              v-model="search.endDate"
              :format="'yyyy-MM-dd HH:mm:ss'"
              utc
              auto-apply
              :close-on-auto-apply="false"
              :placeholder="$t('종료일')"
            ></DatePicker>
          </div>
        </div>
        <div class="col-md-2 mb-2">
          <select class="form-select" v-model="limit">
            <option :value="10">10개</option>
            <option :value="25">25개</option>
            <option :value="50">50개</option>
            <option :value="100">100개</option>
          </select>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <div class="input-group mb-2">
              <button type="button" class="btn btn-outline-success" @click="goFirst">처음</button>
              <button type="button" class="btn btn-outline-primary" @click="goPre">이전</button>
              <input type="number" class="form-control" min="1" v-model="page" />
              <button type="button" class="btn btn-outline-info" @click="goNext">다음</button>
            </div>
          </div>
        </div>
        <div class="form-group col-md-1 mb-2">
          <button type="submit" class="btn btn-dark w-100">검색</button>
        </div>
      </div>
    </form>

    <hr class="mt-0 mb-3" />

    <div class="w-100">
      <div class="d-md-flex">

        <!-- 상위 목록 //-->
        <!-- <partner-tree-menu :partner="$store.getters['auth/user']" @setParent="setParent" @searchList="searchList" ref="partnerTreeMenu" v-if="searchByUser != true"></partner-tree-menu> //-->

        <!-- 목록 //-->

        <div id="table-wrapper" class="table-responsive mb-0 rounded-3 w-100" style="overflow: auto;">
          <div class="w-100">
            <div class="card">
              <div class="card-body">
                <!-- 리스트 //-->

                <table class="table align-middle table-nowrap sticky-table table-striped-columns">
                  <thead class="table-dark">
                  <tr>
                    <th>
                      <a href="javascript:void(0)" @click="setSort('createdAt')">#</a>&nbsp;
                      <template v-if="sort.createdAt"><span class="fa fa-sort-amount-down" v-if="sort.createdAt === -1"></span><span class="fa fa-sort-amount-up" v-if="sort.createdAt === 1"></span></template>
                    </th>
                    <th>{{ $t('라운드 키') }}</th>
                    <th>{{ $t('상위') }}{{ $t('정보') }}</th>
                    <th>{{ $t('회원') }}{{ $t('정보') }}</th>
                    <th>{{ $t('거래형식') }}</th>
                    <th>{{ $t('게임사') }}</th>
                    <th>{{ $t('게임종류') }}</th>
                    <th>{{ $t('게임형식') }}</th>
                    <th>{{ $t('게임명') }}</th>
                    <th>{{ $t('거래방식') }}</th>
                    <th>{{ $t('이전') }}</th>
                    <th>{{ $t('배팅') }}</th>
                    <th>{{ $t('이후') }}</th>
                    <th colspan="2">{{ $t('베팅픽') }}</th>
                    <th>{{ $t('요청일') }}</th>
                    <th>
                      <a href="javascript:void(0)" @click="setSort('createdAt')">{{ $t('처리일') }}</a>&nbsp;
                      <template v-if="sort.createdAt"><span class="fa fa-sort-amount-down" v-if="sort.createdAt === -1"></span><span class="fa fa-sort-amount-up" v-if="sort.createdAt === 1"></span></template>
                    </th>
                  </tr>
                  </thead>

                  <tbody v-for="(group, i) in groupedList" :key="i"
                         class="border-bottom-custom bg-soft mb-5"
                  >
                  <tr >
                    <td :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1" >
                      <span class="badge badge-soft-dark ms-2"  style="cursor: pointer;" @click="openDetail(group.list[0])" v-b-tooltip.hover data-placement="top" :title="'상세내역'">상세보기</span>
                    </td>
                  </tr>

                  <tr v-for="(record, index) in group.list" :key="index">
                    <template v-if="index === 0">

                      <!-- 라운드 아이디  -->
                      <td  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1" >
                        {{record.siteRoundId}}
                      </td>

                      <td :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1"  class="text-start">
                        <router-link :to="'/partner/detail/' + record.top.id" target="_blank" v-if="record.top && record.top.id !== record.user.id && ($store.getters['auth/user'].level != 'super' && $store.getters['auth/user'].level != 'master' && $store.getters['auth/user'].level != 'agent' && $store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.top" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record['super'].id" target="_blank" v-if="record['super'] && record['super'].id !== record.user.id && ($store.getters['auth/user'].level != 'master' && $store.getters['auth/user'].level != 'agent' && $store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.super" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record.master.id" target="_blank" v-if="record.master && record.master.id !== record.user.id && ($store.getters['auth/user'].level != 'agent' && $store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.master" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record.agent.id" target="_blank" v-if="record.agent && record.agent.id !== record.user.id && ($store.getters['auth/user'].level != 'shop')"><partner-badge :partner="record.agent" :show-name="true"></partner-badge></router-link>
                        <router-link :to="'/partner/detail/' + record.shop.id" target="_blank" v-if="record.shop && record.shop.id !== record.user.id"><partner-badge :partner="record.shop" :show-name="true"></partner-badge></router-link>
                      </td>

                      <!-- 회원정보 //-->
                      <td  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1"  class="text-center">
                        <template v-if="record.user">
                          <div v-if="record.user?.type === 'user'" class="ms-1">
                            <router-link :to="'/user/detail/' + record.user.id" target="_blank" rel="noopener noreferrer">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="badge badge-soft-info p-1">사이트</span>
                                <span class="text-end">{{ record.user.siteUsername }}</span>
                              </div>
                              <div class="d-flex justify-content-between align-items-center mt-1">
                                <span class="badge badge-soft-secondary p-1">네오</span>
                                <span class="text-end">{{ record.user.username }}</span>
                              </div>
                            </router-link>
                          </div>

                          <div v-else-if="record.user.type === 'partner'" class="ms-1">
                            <router-link :to="'/partner/detail/' + record.user.id" target="_blank">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="fw-bold">아이디</span>
                                <span class="text-end">{{ record.user.username }}</span>
                              </div>
                              <div class="d-flex justify-content-between align-items-center mt-1">
                                <span class="fw-bold">닉네임</span>
                                <span class="text-end">{{ record.user.nickname }}</span>
                              </div>
                            </router-link>
                          </div>
                        </template>
                      </td>

                      <!-- 거래 형식 //-->
                      <td  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1" >
                        <badge-seamless :use-seamless="record.parent.useSeamless" v-if="record.parent && record.category === 'turn'"></badge-seamless>
                        <badge-transaction-category :record="record"></badge-transaction-category>
                      </td>
                      <!-- 게임사 //-->
                      <td  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1" >
                        <span class="badge bg-danger" v-if="record.isEvent == 1" :hidden="$store.getters['auth/user'].type !== 'admin'">F</span> {{ record.vendorName }}
                      </td>
                      <!-- 게임종류 //-->
                      <td  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1" >
                        <badge-game-category :record="record"></badge-game-category>
                      </td>
                      <!-- 게임형식 //-->
                      <td  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1" >{{ record.gameTypeName.toUpperCase() }}</td>
                      <!-- 게임명 //-->
                      <td :class="{'text-start': record.gameCategoryKey === 'slot'}"
                          :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1" >
                        {{ record.categoryKey }}
                        <img :src="record.gameImage" style="width: 32px;" class="img-thumbnail" v-if="record.gameImage" />
                        {{ record.gameName }}
                      </td>
                    </template>


                    <!-- 거래 방식 //-->
                    <td >
                      <!--
                      method: game, category: money, type: send or receive => 사이트<->케이곤 머니이동
                      method: cash, category: cash(파트너) or money(회원), type: send or receive => 회원간 캐쉬 이동(입/출금)
                      method: game, category: turn, type: bet or win or draw or cancel => 게임 플레이
                      //-->
                      <span class="badge ms-1 badge-soft-danger" style="cursor: pointer;" v-if="record.parent.useSeamless === 1 && record.seamlessState === 'error'" v-b-tooltip.hover data-placement="top" :title="record.seamlessErrorMsg" @click="openSeamlessLog(record)"><i class="fa fa-check"></i></span>
                      <span class="badge badge-soft-dark" style="cursor: pointer;" @click="openData(record)" v-b-tooltip.hover data-placement="top" :title="'게임데이터'"><i class="fa fa-book"></i></span>
                      <badge-transaction-type :record="record"></badge-transaction-type>
                    </td>

                    <!-- 이전 보유알 //-->
                    <td class="text-end">{{ record.beforeAmount.floatVal(2).formatThousands() }}</td>

                    <!-- 금액 //-->
                    <td class="text-end">
                      <!-- 에볼류션 //-->
                      <template v-if="record.info && record.info.code === 0 && record.vendorKey === 'evolution_casino'">
<!--                        <p v-for="(bet, index) in record.info.bets" :key="record.transactionKey + '_' + index">-->
<!--                          <badge-game-target :target="bet.target.toLowerCase()"></badge-game-target>&nbsp;-->
<!--                          <span>{{ bet.bet.formatThousands() }}</span>-->
<!--                        </p>-->
                      </template>
                      <template v-else>
                        {{ record.amount.formatThousands() }}
                      </template>
                    </td>

                    <!-- 수익금 //-->
<!--                    <td class="text-end">-->
<!--                      <template v-if="record.info && record.info.code === 0 && record.vendorKey === 'evolution_casino'">-->
<!--                        <p v-for="(bet, index) in record.info.bets" :key="record.transactionKey + '_result_' + index">-->
<!--                          <badge-game-target :target="record.info.result.toLowerCase()" v-if="record.info && record.info.result"></badge-game-target>&nbsp;-->
<!--                          <span :class="{'text-danger': bet.win <= 0, 'text-primary': bet.win > 0}">{{ bet.win.formatThousands() }}</span>-->
<!--                        </p>-->
<!--                      </template>-->
<!--                    </td>-->

                    <!-- 이후 보유알 //-->
                    <td class="text-end">{{ record.afterAmount.floatVal(2).formatThousands() }}</td>

                    <!-- 베팅픽 //-->
                    <template v-if="index === 0">
                      <template v-if="group.detail.result">

                        <td class=""  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1"  style="min-width: 250px;">
                          <div v-if="group.list.some(r => r.detail?.bets?.length > 0)" class="d-flex fw-bold border-bottom border-1 py-1 bg-dark-subtle">
                            <div class="col text-start">베팅픽</div>
                            <div class="col text-start">베팅금</div>
                            <div class="col text-start">당첨금</div>
                          </div>

                          <!-- 콘텐츠 -->
                          <div v-for="(rec, recIndex) in group.list" :key="recIndex" class="small">
                            <template v-if="rec.detail?.bets?.length > 0">
                              <div v-for="(item, index) in rec.detail.bets" :key="index" class="d-flex py-1 border-bottom">
                                <div class="col text-start">{{ item.target }}</div>
                                <div class="col text-start">{{ item.betAmount.toLocaleString() }}</div>
                                <div class="col text-start">{{ item.winAmount.toLocaleString() }}</div>
                              </div>
                            </template>
                          </div>

                        </td>

                        <td
                          class="small"
                          :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1"
                        >
                          <div class="cards-wrapper">
                            <div class="cards-p"
                                 :style="{
                                    backgroundColor: group.detail?.result?.playerScore > group.detail?.result?.bankerScore
                                    ? '#e4ecff'
                                    : group.detail?.result?.playerScore === group.detail?.result?.bankerScore
                                      ? '#eaffea'
                                      :'transparent'
                                 }">
                              <div class="player-label"><strong>Player</strong></div>
                              <div class="cards">
                                <div class="card" v-for="(c, i) in group.detail?.result?.playerCards" :key="i">
                                  <img :src="require(`@/assets/images/cards/${c}.png`)" class="card-image"/>
                                </div>
                                <div class="card-value"><strong>{{group.detail?.result?.playerScore}}</strong></div>
                              </div>
                            </div>
                            <div class="cards-b"
                                 :style="{
                                    backgroundColor: group.detail?.result?.bankerScore > group.detail?.result?.playerScore
                                    ? '#ffeaea'
                                    : group.detail?.result?.playerScore === group.detail?.result?.bankerScore
                                      ? '#eaffea'
                                      : 'transparent'
                                 }">
                              <div class="banker-label"><strong>Banker</strong></div>
                              <div class="cards">
                                <div class="card" v-for="(c, i) in group.detail?.result?.bankerCards" :key="i">
                                  <img :src="require(`@/assets/images/cards/${c}.png`)" class="card-image"/>
                                </div>
                                <div class="card-value"><strong>{{group.detail?.result?.bankerScore}}</strong></div>
                              </div>
                            </div>
                          </div>
                        </td>

                      </template>
                      <template v-else>
                        <td colspan="2"  :rowspan="(group.list.length + 1 )+ group.childrenList[group.code].length +1"  class="small">
                          {{ '상세 데이터를 받아오는 중 입니다.' }}
                        </td>
                      </template>
                    </template>

                    <!-- 요청일(requestedAt) //-->
                    <td class="small">{{ new Date(record.requestedAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                    <!-- 처리일(createdAt) //-->
                    <td class="small">{{ new Date(record.createdAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                  </tr>

                  <tr v-for="(result, i) in group.childrenList[group.code]" :key="i">
                    <td>
                      <span class="badge ms-1" style="cursor: pointer;"
                            v-if="result.parent.useSeamless === 1 && result.seamlessState === 'error'"
                            :class="{'badge-soft-danger': result.seamlessState === 'error', 'badge-soft-primary': result.seamlessState === 'finish', 'badge-soft-secondary': result.seamlessState === 'ready'}" v-b-tooltip.hover data-placement="top"
                            :title="result.seamlessErrorMsg" @click="openSeamlessLog(result)"><i class="fa fa-check"></i></span>
                      <span class="badge badge-soft-dark" style="cursor: pointer;"
                            @click="openData(result)" v-b-tooltip.hover data-placement="top" :title="'결과데이터'">
                        <i class="fa fa-book"></i>
                      </span>
                      <badge-transaction-type :record="result"></badge-transaction-type>
                    </td>
                    <!-- 이전 //-->
                    <td class="text-end">
                      {{ result.beforeAmount.floatVal(2).formatThousands() }}
                    </td>
                    <!-- 배팅 / 결과 //-->
                    <td v-if="result.vendorKey === 'evolution_casino'">
                      <span >
                        {{ result.amount.formatThousands() }}
                      </span>
                    </td>
                    <td v-else class="text-end" >
                          <span :class="{'text-danger': result.amount <= 0, 'text-primary': result.amount > 0}">
                            {{ result.amount.formatThousands() }}
                          </span>
                    </td>

                    <td class="text-end">
                      {{ result.afterAmount.floatVal(2).formatThousands() }}
                    </td>
                    <td class="small">{{ new Date(result.requestedAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                    <td class="small">{{ new Date(result.createdAt).format('YYYY-MM-DD HH:mm:ss.zzz') }}</td>
                  </tr>

                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Detail ref="modal-detail" />
  </div>
</template>